import Loadable from '../../components/loadable';

const ForgotPasswordForm = Loadable({
  loader: () => import('../../components/forgot_password_form'),
});

angular.module('shared').value('ForgotPasswordForm', ForgotPasswordForm);
